import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_rule_outbound_order_processing_failures_grid___rule_outbound_order_processing_failures_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { rule_id?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, order_id?: number, failure_reason?: string, order_lookup?: string, failed_on?: string, order_status?: string, rule_name?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { rule_id?: string, $keys: string[] }): Promise<{ result?: { id?: string, order_id?: number, failure_reason?: string, order_lookup?: string, failed_on?: string, order_status?: string, rule_name?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      rule_id?: string    }) {
      return false;
    }
}
